// extracted by mini-css-extract-plugin
export var carrierTab = "_3s-0";
export var carrierTabActive = "_3s-1 _3s-0";
export var carrierTabInactive = "_3s-2 _3s-0";
export var carrierTabLabel = "_3s-3";
export var carrierTabLabelActive = "_3s-4 _3s-3";
export var carrierTabLabelInactive = "_3s-5 _3s-3";
export var carrierTabPercentage = "_3s-6";
export var carrierTabPercentageActive = "_3s-7 _3s-6";
export var carrierTabPercentageInactive = "_3s-8 _3s-6";
export var carrierTabWinnable = "_3s-9";
export var carrierTabWinnableActive = "_3s-a _3s-9";
export var carrierTabWinnableInactive = "_3s-b _3s-9";
export var comparisonContainer = "_3s-d";
export var missingRateButton = "_3s-n";
export var missingRateButtonActive = "_3s-o _3s-n";
export var missingRateButtonInactive = "_3s-p _3s-n";
export var missingRateButtonLabel = "_3s-q";
export var missingRateButtonLabelActive = "_3s-r _3s-q";
export var missingRateButtonLabelInactive = "_3s-s _3s-q";
export var sidebar = "_3s-c";
export var strategyButton = "_3s-e";
export var strategyButtonActive = "_3s-f _3s-e";
export var strategyButtonDescription = "_3s-k";
export var strategyButtonDescriptionActive = "_3s-l _3s-k";
export var strategyButtonDescriptionInactive = "_3s-m _3s-k";
export var strategyButtonInactive = "_3s-g _3s-e";
export var strategyButtonLabel = "_3s-h";
export var strategyButtonLabelActive = "_3s-i _3s-h";
export var strategyButtonLabelInactive = "_3s-j _3s-h";
export var unitToggleButton = "_3s-t";
export var unitToggleButtonActive = "_3s-u _3s-t";
export var unitToggleButtonInactive = "_3s-v _3s-t";
export var unitToggleButtonLabel = "_3s-w";
export var unitToggleButtonLabelActive = "_3s-x _3s-w";
export var unitToggleButtonLabelInactive = "_3s-y _3s-w";